import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { OnlineCallBox, DialInput } from './style';
import { callAction } from '../../../store/action';
import { connect } from 'react-redux';
import { Alert } from 'modules/common/utils';
const { v4: uuidv4 } = require('uuid');

export class OnlineCall extends Component {
  constructor(props) {
    super(props);
    this.state = {
      phoneNumber: ''
    };
  }
  sendMessage(type, message) {
    const { callProcess } = this.props;
    callProcess(type, message);
  }
  render() {
    return (
      <OnlineCallBox>
        <DialInput>
          <input
            type="number"
            placeholder="Enter Number"
            onKeyPress={event => {
              if (event.key === 'Enter') {
                if( event.target.value && event.target.value.length > 3 ) {
                  this.setState({phoneNumber : event.target.value})
                  this.sendMessage('callInitiate', {
                    phoneNumber: event.target.value
                  });
                } else {
                  Alert.error(`Please enter valid number`);
                }
              }
            }}
            // onChange={e => {
            //   this.setState({ phoneNumber: e.target.value });
            // }}
          />
        </DialInput>
        <button
          className="dialInputButton"
          onClick={e => {
            // this.setState({ phoneNumber: e.target.value });
            this.sendMessage('callInitiate', {
              phoneNumber: this.state.phoneNumber
            });
          }}
        >
          Call
        </button>
      </OnlineCallBox>
    );
  }
}
OnlineCall.propTypes = {
  callProcess: PropTypes.func
};
OnlineCall.contextTypes = {
  __: PropTypes.func
};

// export default OnlineCall;

const stateToProps = state => ({});

const dispatchToProps = dispatch => ({
  callProcess: (type, messageData) => {
    dispatch(callAction.process(type, messageData));
  }
});
export default connect(stateToProps, dispatchToProps)(OnlineCall);



// WEBPACK FOOTER //
// src/dialpad/components/layout/OnlineCall.js